import { Map } from 'immutable';
import core from './core';

const INITIAL_STATE = new Map({
    list: new Map(),
    initialized: false
});

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'FHEPOOL__SET_USERS':
            return core.setUsers(state, action.users);
        case 'FHEPOOL__FHEPRODUCT_SET_USER':
            return core.setUser(state, action.userId, action.userDetails);
        case 'FHEPOOL__USER_UPDATE_DETAILS':
            return core.updateUser(state, action.userId, action.userDetails);
        case 'FHEPOOL__ADD_USER':
            return core.addUser(state, action.userId, action.userDetails);
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./environments/fhepool/data/Users/reducer.js